const base = process.env.REACT_APP_SERVERURL || "";

const studioJson = async (url: string, init?: RequestInit) => {
  const token = localStorage.getItem("token");
  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };
  if (token) {
    headers.Authorization = "Bearer " + token;
  }
  try {
    const res = await fetch(url, {
      ...init,
      headers: {
        ...headers,
        ...(init?.headers as Record<string, string> | undefined),
      },
    });
    const json = await res.json().catch(() => ({}));
    if (!res.ok) {
      return {
        success: false,
        message: json?.message || "Could not load notifications.",
        data: json?.data ?? null,
      };
    }
    return json;
  } catch {
    return { success: false, message: "Could not reach the server.", data: null };
  }
};

export type StudioInboxItem = {
  id: string;
  type?: string;
  title?: string;
  body?: string;
  productId?: string;
  productName?: string;
  processTitle?: string;
  actionPath?: string;
  read?: boolean;
  createdAt?: string | number | Date;
};

export const listStudioNotifications = (offset = 0, limit = 20) =>
  studioJson(
    `${base}/studio/notifications?offset=${encodeURIComponent(String(offset))}&limit=${encodeURIComponent(String(limit))}`
  );

export const getStudioUnreadCount = () =>
  studioJson(`${base}/studio/notifications/unread-count`);

export const markStudioNotificationRead = (id: string) =>
  studioJson(`${base}/studio/notifications/${encodeURIComponent(id)}/read`, {
    method: "POST",
    body: JSON.stringify({}),
  });

export const markAllStudioNotificationsRead = () =>
  studioJson(`${base}/studio/notifications/read-all`, {
    method: "POST",
    body: JSON.stringify({}),
  });
